export const SP_CLASSES = {
  EDITABLE_ITEM: 'editableItem',
  EDITABLE_BACKGROUND_IMAGE: 'editableBackgroundImage',
};
